import * as FlipdishApi from '@flipdish/api-client-typescript';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { styled, withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import $ from 'jquery';
import * as React from 'react';
import Skeleton from 'react-loading-skeleton';
import ProgressiveImage from 'react-progressive-image';
import { Typography } from '../../../ui';
import * as Api from '../../Api';
import { Data, Item } from '../../BasketControl';
import { COLLAPSE_TIME, MOBILE_MODE_LIMIT } from '../../constants/Constants';
import * as Routes from '../../Routes';
import * as Store from '../../Store';
import * as Utilities from '../../Utilities';
import FlipdishMenuItem from '../MenuItem';
const filter = require('lodash/filter');

require('smoothscroll-polyfill').polyfill();

interface MenuSectionProps {
  MenuId: number;
  MenuSectionId: number;
  Name: string;
  Description: string;
  DisplayOrder: number;
  HandleClickItem: (payload: { menuId: number; item: Api.MenuItem }) => any;
  Items: Api.MenuItem[];
  Basket: Data;
  Currency: Api.Currency;
  AddItemToBasket: (payload: Item) => void;
  RemoveItemAt: (payload: { menuId: number; index: number; indexName?: string }) => void;
  ImageUrl: string | null;
  MenuSectionAvailability: Api.MenuSectionAvailability;
  Restaurant: Routes.RouteRestaurant;
  MenuSectionBehaviour: Api.MenuSectionBehaviour | FlipdishApi.Menu.MenuSectionBehaviourEnum;
  ExpandedState: number[];
  InitializeExpandedState: (vrid: number, expandedState: number[]) => any;
  AddToExpandedState: (vrid: number, menuSectionId: number) => any;
  RemoveFromExpandedState: (vrid: number, menuSectionId: number) => any;
  vrid: number;
  EditMode: boolean;
  HideHidden: boolean;
  IsAvailable: boolean;
  translate: any;
  Languages: Store.Language[];
  AppDesignScheme: Api.AppDesignScheme;
  isDark: boolean;
}

interface State {
  Collapsed: boolean;
  Display: boolean;
  MobileMode: boolean;
}

const ExpansionPanelStyled = withStyles<'root'>((theme) => ({
  root: {
    border: 'none',
    boxShadow: 'none',
    '&>.MuiExpansionPanelSummary-root': {
      paddingLeft: 0,
      border: `1px solid ${theme.palette.divider}`,
      boxShadow: `${theme.palette.divider} 1px 1px 9px -5px`,
      backgroundColor: 'rgb(247, 247, 247)',
      ...(theme.palette.type === 'dark'
        ? {
            backgroundColor: theme.palette.background.paper,
            borderColor: '#fff'
          }
        : {}),
      '&>.MuiExpansionPanelSummary-content': {
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        '&>.MuiTypography-root': {
          marginLeft: '20px',
          paddingTop: '8px',
          paddingBottom: '8px'
        }
      }
    }
  }
}))(ExpansionPanel);

const PanelDetailsStyled = styled(ExpansionPanelDetails)({
  display: 'block',
  padding: 0
});

class MenuSection extends React.Component<MenuSectionProps, State> {
  public displayName: 'Menu Section';

  constructor(props: MenuSectionProps, context: any) {
    super(props, context);
    this.state = {
      Collapsed: null,
      Display: true,
      MobileMode:
        Utilities.flipdiv && !Utilities.extraOption('data-menuid')
          ? $(Utilities.flipdiv).width() < MOBILE_MODE_LIMIT
          : window.innerWidth < MOBILE_MODE_LIMIT
    };
  }

  private updateMobileMode() {
    if (
      (Utilities.flipdiv &&
        !Utilities.extraOption('data-menuid') &&
        $(Utilities.flipdiv).width() < MOBILE_MODE_LIMIT) ||
      (Utilities.extraOption('data-menuid') && window.innerWidth < MOBILE_MODE_LIMIT)
    ) {
      this.setState({ MobileMode: true });
    } else {
      this.setState({ MobileMode: false });
    }
  }

  public componentDidMount() {
    this.updateMobileMode();
    window.addEventListener('resize', this.updateMobileMode.bind(this));
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.updateMobileMode.bind(this));
  }

  public componentDidUpdate() {
    this.initOnce();
  }
  public UNSAFE_componentWillMount() {
    const { MenuSectionId, ExpandedState } = this.props;

    if (typeof ExpandedState != 'undefined') {
      const shouldBeExpanded = ExpandedState.find((element) => {
        return element === MenuSectionId;
      });

      if (typeof shouldBeExpanded != 'undefined') {
        this.setState({ Collapsed: false });
      } else {
        this.setState({ Collapsed: true });
      }
    }
  }

  public UNSAFE_componentWillReceiveProps(newProps: MenuSectionProps) {
    const { MenuSectionId, ExpandedState } = newProps;

    if (typeof ExpandedState != 'undefined') {
      const shouldBeExpanded = ExpandedState.find((element) => {
        return element === MenuSectionId;
      });

      if (typeof shouldBeExpanded != 'undefined') {
        this.setState({ Collapsed: false });
      } else {
        this.setState({ Collapsed: true });
      }
    }
  }

  private initialized = false;
  private initOnce = () => {
    const { MenuSectionAvailability, MenuSectionBehaviour, Restaurant, MenuSectionId } = this.props;

    if (this.initialized) {
      return;
    }

    // eslint-disable-next eqeqeq
    if (!MenuSectionAvailability || MenuSectionBehaviour == null || !MenuSectionId) {
      return;
    }

    switch (Restaurant.status) {
      case 'none':
      case 'pending':
        return;
      default:
        break;
    }

    switch (MenuSectionAvailability.AvailabilityMode) {
      case Api.MenuEntityAvailabilityMode.DisplayBasedOnTimes:
        if (
          MenuSectionAvailability.AvailableTimes != null &&
          !Utilities.isInPeriod(
            MenuSectionAvailability.AvailableTimes,
            // .map(p => ({
            //   ...p,
            //   StartTime: '08:00:00',
            //   Period: '04:00:00'
            // }))
            Restaurant.data.TimeZoneInfoId
          )
        ) {
          this.setState({ Display: false });
        }
        break;
    }
    this.initialized = true;
  };

  private toggleCollapse = (): any => {
    const {
      MenuSectionBehaviour,
      MenuSectionId,
      InitializeExpandedState,
      AddToExpandedState,
      RemoveFromExpandedState,
      vrid
    } = this.props;

    if (this.state.Collapsed) {
      if (MenuSectionBehaviour === Api.MenuSectionBehaviour.ExpandSingle) {
        InitializeExpandedState(vrid, [MenuSectionId]);
      } else {
        AddToExpandedState(vrid, MenuSectionId);
      }
    } else {
      RemoveFromExpandedState(vrid, MenuSectionId);
    }

    this.setState({}, () => {
      if (!this.state.Collapsed) {
        setTimeout(() => {
          const menuSectionElement = document.getElementById(`${MenuSectionId}`);
          if (menuSectionElement) {
            menuSectionElement.scrollIntoView({ behavior: 'smooth' });
          }
        }, COLLAPSE_TIME);
      }
    });
  };

  public render() {
    const {
      Items,
      Basket,
      RemoveItemAt,
      AddItemToBasket,
      Currency,
      vrid,
      ImageUrl,
      MenuSectionId,
      MenuId,
      translate,
      Languages,
      AppDesignScheme,
      isDark
    } = this.props;

    const { Collapsed, Display } = this.state;

    if (Collapsed === null) {
      return null;
    }

    if (!Display) {
      return null;
    }

    const self = this;

    const items = Items.sort((a, b) => a.DisplayOrder - b.DisplayOrder).map(
      (item: Api.MenuItem) => {
        const handleClick = function() {
          self.props.HandleClickItem({ menuId: self.props.MenuId, item });
        };

        const basketCount = filter(Basket.items, (b) => b.Item.MenuItemId === item.MenuItemId)
          .length;

        return (
          <FlipdishMenuItem
            key={item.MenuItemId}
            MenuId={MenuId}
            MenuSectionId={MenuSectionId}
            Basket={Basket}
            RemoveItemAt={RemoveItemAt}
            AddItemToBasket={AddItemToBasket}
            basketCount={basketCount}
            Currency={Currency}
            HandleClickItem={handleClick}
            Item={item}
            vrid={vrid}
            translate={translate}
            Languages={Languages}
            AppDesignScheme={AppDesignScheme}
            isDark={isDark}
          />
        );
      }
    );

    const firstColumn = [];
    const secondColumn = [];

    for (let i = 0; i < items.length; i++) {
      if (i % 2 === 0) {
        firstColumn.push(items[i]);
      } else {
        secondColumn.push(items[i]);
      }
    }

    return (
      <div
        id={`${MenuSectionId}`}
        className={`menu-section-draggable ${
          !this.props.IsAvailable
            ? this.props.EditMode && !this.props.HideHidden
              ? 'masked'
              : 'invisible'
            : ''
        }`}
      >
        <div className="menu-section-draggable__holder">
          <ExpansionPanelStyled
            expanded={!this.state.Collapsed}
            onChange={this.toggleCollapse}
            square
            TransitionProps={{
              mountOnEnter: true,
              unmountOnExit: true,
              timeout: 0
            }}
          >
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon color="primary" />}
              aria-controls={`panel-content-${this.props.MenuSectionId}`}
              id={`panel-header-${this.props.MenuSectionId}`}
            >
              {ImageUrl && (
                <ProgressiveImage
                  src={`${ImageUrl}?w=100&h=80`}
                  // src={`${'https://flipdish.imgix.net/JXypSAb6IzOKc21stIAboNLkxrQ.jpg'}?w=100&h=80`}
                  placeholder=""
                >
                  {(src, loading) => {
                    return loading ? (
                      <div
                        style={{
                          width: '100px',
                          height: '80px'
                        }}
                      >
                        <Skeleton width={'100px'} height={'78px'} />
                      </div>
                    ) : (
                      <img
                        src={src}
                        srcSet={`${src} 1x, ${src}&dpr=2 2x, ${src}&dpr=3 3x`}
                        alt=""
                      />
                    );
                  }}
                </ProgressiveImage>
              )}

              <Typography variant="h3" color="primary">
                {this.props.Name}
                {this.props.Description && (
                  <Typography variant="body1" color="textSecondary" display="block">
                    {this.props.Description}
                  </Typography>
                )}
              </Typography>
            </ExpansionPanelSummary>

            <PanelDetailsStyled>
              {this.state.MobileMode ? (
                <section className="row menu__items">
                  <div className="col-md-12">
                    <div className={`menu__items__column padding-left-zero padding-right-zero`}>
                      {items}
                    </div>
                  </div>
                </section>
              ) : items.length === 0 ? (
                <section className="row menu__items">
                  <div className="col-md-12">
                    <div className={`menu__items__column padding-left-zero padding-right-zero`}>
                      {items}
                    </div>
                  </div>
                </section>
              ) : (
                <section className="row menu__items">
                  <div className="col-md-6">
                    <div className={`menu__items__column padding-left-zero`}>{firstColumn}</div>
                  </div>
                  <div className="col-md-6">
                    <div className={`menu__items__column padding-right-zero`}>{secondColumn}</div>
                  </div>
                </section>
              )}
            </PanelDetailsStyled>
          </ExpansionPanelStyled>
        </div>
      </div>
    );
  }
}

export default MenuSection;
